export default {
    ENTER_EMAIL: 'Enter your email address',
    ENTER_PASSWORD: 'Enter your password',
    LABEL_EMAIL: 'Email',
    LABEL_PASSWORD: 'Password',
    TITLE: 'Sign in',
    SUB_TITLE: 'Enter your email and password to sign in',
    PERSIST_AUTH: 'Keep me signed in',
    FORGOT_PASSWORD: 'Forgot password?',
    LOGIN: 'Sign in',
    LOGIN_WITH: 'Or continue with',
    SIGN_IN_PROVIDER: 'Sign in with',
    AUTH_ERROR: 'Backend error',
};
